/**
 * Карта жизни (A5): 80 клеток, одна клетка — один год. Прожитый — чернила,
 * текущий — охра, будущее — пунктир; помеченные ☆ годы — с точкой.
 * У умершего охры нет: прожито ровно `age` клеток (0 лет — пустая карта).
 *
 * Карта — визуальный элемент: клетка на телефоне ≈ 5px, тап-зоны 44px тут
 * невозможны, поэтому клетки не кнопки (`aria-hidden`, без событий).
 * Пометить год ☆ и записать «мысль» можно через строки журнала.
 */
import type { Life } from '@life/engine';
import { t } from '@life/i18n';

export const LIFE_MAP_CELLS = 80;

export interface LifeMapProps {
  life: Life;
}

export function LifeMap({ life }: LifeMapProps) {
  const starred = new Set(life.log.filter((e) => e.starred).map((e) => e.age));

  const cells = Array.from({ length: LIFE_MAP_CELLS }, (_, age) => {
    const state = age < life.age ? 'on' : age === life.age && life.alive ? 'now' : 'off';
    const cls = starred.has(age) ? `${state} starred` : state;
    return <i key={age} class={cls} data-age={age} />;
  });

  return (
    <div class="lifemap">
      <div class="strip" aria-hidden="true">
        {cells}
      </div>
      <div class="cap">{t('ui.life.map.caption')}</div>
    </div>
  );
}
